'use client';
import { useUnifiedUiSidebarVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useUnifiedUiSidebarVariation.js';
import { getCachedFlagValueKey } from '#pplx/frontend/experimentation/cachedFlagValue.js';
import { makeCachedFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
const UNIFIED_UI_SIDEBAR_FLAG = 'unified-ui-sidebar';
const useCachedUnifiedUiSidebarVariation = makeCachedFlagValueHook(getCachedFlagValueKey(UNIFIED_UI_SIDEBAR_FLAG), useUnifiedUiSidebarVariation, UNIFIED_UI_SIDEBAR_FLAG);
export function useUnifiedUiSidebarEnabled() {
    return useCachedUnifiedUiSidebarVariation({ defaultValue: false });
}
//# sourceMappingURL=useUnifiedUiSidebarEnabled.js.map